import { render } from "./ItemClassificationList.vue?vue&type=template&id=95265904"
import script from "./ItemClassificationList.vue?vue&type=script&lang=js"
export * from "./ItemClassificationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__